var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-group filterfield",
      attrs: {
        id: _vm.htmlId,
        "data-filterfield-type": _vm.definition.componentName,
      },
    },
    [
      _vm.showLabel
        ? _c(
            "label",
            { staticClass: "col-xs-12", attrs: { for: _vm.inputId } },
            [
              _vm._v(_vm._s(_vm.displayName) + " "),
              _c("Debug", [_vm._v("(id: " + _vm._s(_vm.id) + ")")]),
            ],
            1
          )
        : _c("Debug", [
            _c("label", { staticClass: "col-xs-12" }, [
              _vm._v("(id: " + _vm._s(_vm.id) + ")"),
            ]),
          ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xs-12" },
        [
          _c("SelectPicker", {
            attrs: {
              "data-width": "100%",
              multiple: "",
              container: "body",
              "data-id": _vm.inputId,
              "data-name": _vm.inputId,
              dir: _vm.textDirection,
              placeholder: _vm.displayName,
              options: _vm.options,
              searchable: _vm.searchable,
              value: _vm.value,
            },
            on: {
              input: function ($event) {
                _vm.log("input", $event)
                _vm.e_input($event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }